import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class I18nLoaderService {
  private readonly  http = inject(HttpClient);

  private readonly translate = inject(TranslateService);

  async load(part: string) {
    const lang = this.translate.getCurrentLang() ?? 'en';
     try {
        const translations = await firstValueFrom(
          this.http.get<Record<string, any>>(`/i18n/${lang}/${part}.json`),
        );

        this.translate.setTranslation(lang, translations, true);
        } catch {
      // Em SSR a requisição pode ser cancelada antes de completar;
      // ignoramos aqui pois o cliente refaz o load na hidratação.
    }
  }
}
